import { Routes, Route, Navigate } from 'react-router-dom'
import GlobalLayout from './components/layout/GlobalLayout'
import ProtectedRoute from './components/ProtectedRoute'
import PageWrapper from './components/PageWrapper'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'
import Dashboard from './pages/Dashboard'
import DashboardMobile from './pages/mobile/DashboardMobileExact'
import Usuarios from './pages/Usuarios'
import Mascotas from './pages/Mascotas'
import MascotasMobile from './pages/mobile/MascotasMobile'
import MascotaDetailMobile from './pages/mobile/MascotaDetailMobileExact'
import Citas from './pages/Citas'
import CitasMobile from './pages/mobile/CitasMobile'
import CitaDetailMobile from './pages/mobile/CitaDetailMobile'
import Fichas from './pages/Fichas'
import FichasMobile from './pages/mobile/FichasMobile'
import FichaDetailMobile from './pages/mobile/FichaDetailMobile'
import Veterinarios from './pages/Veterinarios'
import Reportes from './pages/Reportes'
import Notificaciones from './pages/Notificaciones'
import Configuracion from './pages/Configuracion'
import SuscripcionesPendientes from './pages/SuscripcionesPendientes'
import Perfil from './pages/Perfil'
import NotificacionesMobile from './pages/mobile/NotificacionesMobileExact'
import PerfilMobile from './pages/mobile/PerfilMobileExact'
import PerfilEditMobile from './pages/mobile/PerfilEditMobileExact'
import Clinicas from './pages/Clinicas'
import ClinicasMobile from './pages/mobile/ClinicasMobileVectorExact'
import ClinicaDetailMobile from './pages/mobile/ClinicaDetailMobileExact'
import SuscripcionesClinicas from './pages/SuscripcionesClinicas'
import AccesoMascotas from './pages/AccesoMascotas'
import EditarMascota from './pages/EditarMascota'
import { usePermissions } from './hooks/usePermissions'

function App() {
  const { isVeterinarioAdmin } = usePermissions()

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <GlobalLayout />
          </ProtectedRoute>
        }
      >
        <Route 
          index 
          element={
            <PageWrapper 
              MobileComponent={DashboardMobile}
              DesktopComponent={Dashboard}
            />
          } 
        />
        {/* Rutas restringidas solo para ADMIN y SUPERADMIN */}
        <Route 
          path="usuarios" 
          element={
            <ProtectedRoute allowedRoles={['SUPERADMIN']}>
              <Usuarios />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="mascotas" 
          element={
            <PageWrapper 
              MobileComponent={MascotasMobile}
              DesktopComponent={Mascotas}
            />
          } 
        />
        <Route 
          path="mascotas/:id" 
          element={<MascotaDetailMobile />} 
        />
        <Route
          path="mascotas/:id/edit"
          element={
            <PageWrapper
              MobileComponent={EditarMascota}
              DesktopComponent={EditarMascota}
            />
          }
        />
        <Route 
          path="citas" 
          element={
            <PageWrapper 
              MobileComponent={CitasMobile}
              DesktopComponent={Citas}
              useMobileForAllRoles
            />
          } 
        />
        <Route
          path="citas/:id"
          element={
            <PageWrapper
              MobileComponent={CitaDetailMobile}
              DesktopComponent={CitaDetailMobile}
              useMobileForAllRoles
            />
          }
        />
        <Route 
          path="fichas" 
          element={
            <PageWrapper 
              MobileComponent={FichasMobile}
              DesktopComponent={Fichas}
            />
          } 
        />
        <Route 
          path="fichas/:id" 
          element={<FichaDetailMobile />} 
        />
        <Route 
          path="clinicas" 
          element={
            <ProtectedRoute allowedRoles={['ADMIN', 'SUPERADMIN', 'VETERINARIO']}>
              <PageWrapper
                MobileComponent={ClinicasMobile}
                DesktopComponent={Clinicas}
                useMobileForAllRoles
              />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="veterinarios" 
          element={
            <ProtectedRoute allowedRoles={['ADMIN', 'SUPERADMIN', 'VETERINARIO']}>
              <Veterinarios />
            </ProtectedRoute>
          } 
        />
        <Route
          path="reportes"
          element={
            <ProtectedRoute allowedRoles={['ADMIN', 'SUPERADMIN', 'VETERINARIO']}>
              <Reportes />
            </ProtectedRoute>
          }
        />
        <Route
          path="notificaciones"
          element={
            <PageWrapper
              MobileComponent={NotificacionesMobile}
              DesktopComponent={Notificaciones}
            />
          }
        />
        <Route
          path="perfil"
          element={
            <PageWrapper
              MobileComponent={PerfilMobile}
              DesktopComponent={Perfil}
            />
          }
        />
        <Route
          path="perfil/editar"
          element={
            <PageWrapper
              MobileComponent={PerfilEditMobile}
              DesktopComponent={Perfil}
            />
          }
        />
        <Route
          path="suscripciones-clinicas"
          element={
            <ProtectedRoute allowedRoles={['DUEÑO']}>
              <PageWrapper
                MobileComponent={ClinicasMobile}
                DesktopComponent={SuscripcionesClinicas}
                useMobileForAllRoles
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="suscripciones-clinicas/:id"
          element={
            <ProtectedRoute allowedRoles={['DUEÑO']}>
              <PageWrapper
                MobileComponent={ClinicaDetailMobile}
                DesktopComponent={ClinicaDetailMobile}
                useMobileForAllRoles
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="acceso-mascotas"
          element={
            <ProtectedRoute allowedRoles={['VETERINARIO', 'PET_SITTER', 'ADMIN', 'SUPERADMIN']}>
              <AccesoMascotas />
            </ProtectedRoute>
          }
        />
        <Route 
          path="suscripciones-pendientes" 
          element={
            <ProtectedRoute allowedRoles={['VETERINARIO']}>
              {isVeterinarioAdmin ? <SuscripcionesPendientes /> : <Navigate to="/" replace />}
            </ProtectedRoute>
          } 
        />
        <Route path="configuracion">
          <Route 
            path="roles" 
            element={
              <ProtectedRoute allowedRoles={['SUPERADMIN']}>
                <Configuracion />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="condiciones-salud" 
            element={
              <ProtectedRoute allowedRoles={['SUPERADMIN']}>
                <Configuracion />
              </ProtectedRoute>
            } 
          />
          <Route
            path="push-condicion-salud"
            element={
              <ProtectedRoute allowedRoles={['SUPERADMIN']}>
                <Configuracion />
              </ProtectedRoute>
            }
          />
          <Route
            path="seo"
            element={
              <ProtectedRoute allowedRoles={['SUPERADMIN']}>
                <Configuracion />
              </ProtectedRoute>
            }
          />
          <Route 
            path="paises" 
            element={
              <ProtectedRoute allowedRoles={['SUPERADMIN']}>
                <Configuracion />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="sistema" 
            element={
              <ProtectedRoute allowedRoles={['SUPERADMIN']}>
                <Configuracion />
              </ProtectedRoute>
            } 
          />
          <Route 
            index 
            element={
              <ProtectedRoute allowedRoles={['SUPERADMIN']}>
                <Configuracion />
              </ProtectedRoute>
            } 
          />
        </Route>
      </Route>
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App

